const FEATURES = [
  { feature: 'Mapa natal completo',                  professya: true,         costar: true,       astrocom: true       },
  { feature: 'Leitura gerada no momento, 100% sua',  professya: true,         costar: false,      astrocom: false      },
  { feature: 'Previsões diárias/semanais/mensais',   professya: true,         costar: true,       astrocom: false      },
  { feature: 'Tarô + I Ching + Numerologia',         professya: true,         costar: false,      astrocom: false      },
  { feature: 'Sinastria completa',                   professya: true,         costar: 'parcial',  astrocom: 'parcial'  },
  { feature: 'Design Humano + Astrologia Védica',    professya: true,         costar: false,      astrocom: false      },
  { feature: 'Astrocartografia',                     professya: true,         costar: false,      astrocom: false      },
  { feature: 'Em Português nativo',                  professya: true,         costar: false,      astrocom: false      },
  { feature: 'Preço mensal',                         professya: 'R$ 24,90',   costar: '~R$ 85',   astrocom: 'Grátis/€' },
];

type ColVal = boolean | string;

function Check({ val, highlight }: { val: ColVal; highlight?: boolean }) {
  if (val === true)      return <span style={{ color: '#4ade80', fontWeight: 700, fontSize: '1.1rem' }}>✓</span>;
  if (val === false)     return <span style={{ color: 'rgba(200,220,235,0.3)', fontSize: '1.1rem' }}>×</span>;
  if (val === 'parcial') return <span style={{ color: '#fbbf24' }}>~</span>;
  return (
    <span style={{
      fontSize: 'var(--text-caption)',
      color: highlight ? '#D4AF37' : 'rgba(200,220,235,0.55)',
      fontWeight: highlight ? 700 : 400,
    }}>
      {val as string}
    </span>
  );
}

export function ComparisonTable() {
  return (
    <section style={{
      padding: 'clamp(4rem, 8vw, 7rem) 2rem',
      background: 'radial-gradient(ellipse at 50% 100%, #1A0B2E 0%, #0A0416 60%)',
      borderTop: '1px solid rgba(212,175,55,0.1)',
    }}>
      <div style={{ maxWidth: '860px', margin: '0 auto' }}>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase' as const,
          color: '#D4AF37',
          textAlign: 'center',
          marginBottom: '1.5rem',
        }}>
          Por que Professya?
        </p>
        <h2 style={{
          textAlign: 'center',
          margin: '0 0 3rem',
          color: 'rgba(240,246,252,0.95)',
          fontFamily: 'var(--font-display)',
        }}>
          A mais completa em português.
        </h2>

        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%', borderCollapse: 'collapse',
            fontFamily: 'var(--font-body)', fontSize: 'var(--text-13)',
          }}>
            <thead>
              <tr>
                <th style={{
                  textAlign: 'left', padding: '0.875rem 1rem',
                  color: 'rgba(200,220,235,0.35)', fontWeight: 400,
                  borderBottom: '1px solid rgba(212,175,55,0.15)',
                }} />
                {[
                  { name: 'Professya', highlight: true },
                  { name: 'Co-Star',   highlight: false },
                  { name: 'Astro.com', highlight: false },
                ].map(({ name, highlight }) => (
                  <th key={name} style={{
                    padding: '0.875rem 1rem', fontWeight: 600,
                    fontSize: 'var(--text-15)',
                    color: highlight ? '#D4AF37' : 'rgba(200,220,235,0.4)',
                    borderBottom: '1px solid rgba(212,175,55,0.15)',
                    background: highlight ? 'rgba(212,175,55,0.06)' : 'transparent',
                    textAlign: 'center',
                  }}>{name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {FEATURES.map(({ feature, professya, costar, astrocom }, i) => (
                <tr key={feature} style={{ background: i % 2 === 0 ? 'rgba(15,6,32,0.5)' : 'transparent' }}>
                  <td style={{
                    padding: '0.75rem 1rem',
                    color: 'rgba(240,246,252,0.8)',
                    borderBottom: '1px solid rgba(212,175,55,0.08)',
                  }}>
                    {feature}
                  </td>
                  {([professya, costar, astrocom] as ColVal[]).map((val, j) => (
                    <td key={j} style={{
                      padding: '0.75rem 1rem', textAlign: 'center',
                      borderBottom: '1px solid rgba(212,175,55,0.08)',
                      background: j === 0 ? 'rgba(212,175,55,0.06)' : 'transparent',
                    }}>
                      <Check val={val} highlight={j === 0} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
